module.exports = __webpack_public_path__ + "static/media/predator.f36e130e.jpg";